import { Modal, useModals } from 'almanac-ui/Modal'
import Styles from './BrandWizardVisualAnalysisModal.module.scss'
import { BrandWizardVisualAnalysisModalProps } from './Types'
import { getPropsFromIntegration } from 'components/IntegrationsModal/ManageIntegrationAccounts/utils'
import { useRef, useState } from 'react'
import { Body } from './Body'
import { Button } from 'blaze-ui/Button'
import { BrandVisualAnalysisResult } from 'types'
import { BrandWizardVisualAnalysisProvider } from './BrandWizardVisualAnalysisContext'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { ArrowLeft } from 'blaze-ui/icons'

const BrandWizardVisualAnalysisModal = ({
  integration,
  initialAnalysisId,
  onConfirm,
  onBack,
}: BrandWizardVisualAnalysisModalProps) => {
  const { closeModal } = useModals()
  const continueContainerRef = useRef<HTMLDivElement>(null)
  const regenerateContainerRef = useRef<HTMLDivElement>(null)
  const [result, setResult] = useState<BrandVisualAnalysisResult>({
    colors: [],
    font_pairings: [],
    logo: '',
  })
  const { isMobile } = useResponsiveDesign()

  const { name } = getPropsFromIntegration(integration)

  return (
    <BrandWizardVisualAnalysisProvider result={result} onChange={setResult}>
      <Modal.Root size="md">
        <Modal.Header title={name} />
        <Modal.Content>
          <Body
            initialId={initialAnalysisId}
            integration={integration}
            continueContainerRef={continueContainerRef}
            regenerateContainerRef={regenerateContainerRef}
            onConfirm={onConfirm}
          />
        </Modal.Content>
        <div className={Styles.footer}>
          <div className={Styles.actions}>
            <div ref={continueContainerRef} className={Styles.continueContainer} />
            <div className={Styles.backAndRegenerateContainer}>
              <Button
                size="lg"
                variant="tertiary"
                onPress={() => {
                  closeModal()
                  onBack?.()
                }}
                fullWidth={isMobile}
                frontIcon={ArrowLeft}
              >
                Back
              </Button>
              <div ref={regenerateContainerRef} className={Styles.regenerateContainer} />
            </div>
          </div>
        </div>
      </Modal.Root>
    </BrandWizardVisualAnalysisProvider>
  )
}

export { BrandWizardVisualAnalysisModal }
